/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from "react";

import Navbar from "./Navbar";
import Footer from "./Footer";
import SubscribeToNewsletterModal from "../SubscribeToNewsletterModal";

const Layout = ({ children, location = { pathname: "" } }: { children: React.ReactNode; location: any }) => {
  const [showNewsletterModal, setShowNewsletterModal] = React.useState(false);

  React.useEffect(() => {
    // Check if user has already subscribed or dismissed the modal
    const hasSubscribed = localStorage.getItem("newsletter_subscribed");
    const isAuthPage = location?.pathname.indexOf("/login") === 0 || location?.pathname.indexOf("/register") === 0;

    // Show modal after 5 seconds if user hasn't subscribed and not on admin/auth pages
    if (!hasSubscribed && !isAuthPage) {
      const timer = setTimeout(() => {
        setShowNewsletterModal(true);
      }, 5000); // 5 seconds delay

      return () => clearTimeout(timer);
    }
  }, []);

  const haveLayout = () => {
    return (
      location?.pathname.indexOf("/contact") !== 0 &&
      location?.pathname.indexOf("/login") !== 0 &&
      location?.pathname.indexOf("/register") !== 0 &&
      location?.pathname.indexOf("/check-certificate") !== 0 &&
      location?.pathname.indexOf("/customer-feedback") === -1 &&
      location?.pathname.indexOf("/academy") !== 0
    );
  };

  location?.pathname.indexOf("/customer-feedback");

  return (
    <>
      <SubscribeToNewsletterModal show={showNewsletterModal} hide={() => setShowNewsletterModal(false)} />
      {haveLayout() ? <Navbar location={location} /> : ""}
      <div className="pt-[236px">{children}</div>
      {haveLayout() ? <Footer onOpenNewsletterModal={() => setShowNewsletterModal(true)} /> : ""}
    </>
  );
};

export default Layout;
